import { FormattedToNumber, CurrencyString } from './types';

const parseCurrencyStringToNumber = (
  value: CurrencyString
): FormattedToNumber => {
  if (!value) {
    return;
  }

  return Number(value.replace(/[^0-9,]/g, '').replace(',', '.'));
};

export default parseCurrencyStringToNumber;
